@if (initialized) {
  <div class="auth-container">
    <div class="login-box mx-3">
      <div class="surface-card sm:p-5 p-3 shadow-2 border-round-2xl w-full">

        <form class="flex flex-column w-full mt-4 sm:px-3 px-1">
          <div class="flex justify-content-center mb-5">
        <span class="border-circle flex justify-content-center align-items-center bg-green-50">
<!--          <i class="pi pi-check text-green-600 text-5xl"></i>-->
          <img src="../../../../assets/images/klaus_party.png" class="w-20rem block" alt="logo">
        </span>
          </div>
          <div class="mb-5">
            <p class="font-semibold text-3xl mt-0 mb-2 text-color text-center">Registrierung erfolgreich!</p>
            <p class="text-center mt-0 mb-3 text-color-secondary text-center">Herzlich willkommen an Bord! Alles ist bereit für den Start deiner Reise mit uns.
          </div>


          <div class="flex justify-content-center">
            <button pButton pRipple (click)="handleNavigation()" label="Weiter geht's zum Onboarding"></button>
          </div>

        </form>

      </div>
    </div>
  </div>
}
